export default __webpack_public_path__ + "static/media/godkend.566a5f35.png";